export default __webpack_public_path__ + "static/media/forum_img_2.e61199c9.svg";